import {
  LIST_DATASHEET_FORMAT_SUCCESS,
  LIST_DATASHEET_FORMAT_ERROR,
  LIST_DATASHEET_FORMAT_REQUEST
} from 'constants/actionTypes'

const DEFAULT_STATE = {
  datasheetFormatList: [],
  error: null,
}

export default (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case LIST_DATASHEET_FORMAT_REQUEST:
  return { ...state, error: null }
    case LIST_DATASHEET_FORMAT_SUCCESS:
      return { ...state, datasheetFormatList: action.payload, error: null }
    case LIST_DATASHEET_FORMAT_ERROR:
      return { ...state, error: action.payload }
    default:
      return { ...state }
  }
}
